// extracted by mini-css-extract-plugin
export default {"pricing":"pricing__ZjQzZ","section":"section__ZGY5M","title":"title__OTllM","icon":"icon__OGZiZ","link":"link__M2IwM"};